import { Typography } from "@mui/material";
import { type FC, useMemo } from "react";

import { usePreviewContext } from "../preview-context";
import { useEmailPreviewSource } from "../hooks/use-email-preview-source";
import { usePreviewTags } from "../hooks/use-preview-tags";

export const PreviewBodySubject: FC<{ isNewsletter: boolean }> = () => {
  const {
    moment_preview_data: { dynamic_segment_id_map },
    preview_info,
    preview_test_data,
  } = usePreviewContext();

  const {
    subject: emailSubject,
    design,
    additional_merge_fields: email_additional_merge_fields,
    use_unlayer_email_preview,
  } = useEmailPreviewSource();

  const { data } = usePreviewTags({
    dynamic_segment_id_map,
    preview_info,
    preview_test_data,
    design,
    subject: emailSubject,
    email_additional_merge_fields,
    use_unlayer_email_preview,
  });

  const subject = useMemo(() => {
    if (!data?.tags || !emailSubject) return emailSubject;

    return data.tags.reduce((acc, item) => {
      return acc.replaceAll(`{{${item.key}}}`, item.value);
    }, emailSubject);
  }, [data, emailSubject]);

  return <Typography variant="body2">{`Subject: ${subject}`}</Typography>;
};
